"use client";

import React from "react";
import { MarkdownComponents } from "./markdown-components";

interface StreamingContentProps {
  content: string;
}

/**
 * Live streaming view for the full AI summary card.
 *
 * Renders markdown as tokens arrive from the stream, with a blinking cursor to
 * signal that generation is still in progress. This is what lets a user start
 * reading the summary before it finishes — the collapsible SummaryContent
 * teaser only takes over once streaming completes.
 */
export function StreamingContent({ content }: StreamingContentProps) {
  return (
    <div className="text-sm md:text-base leading-relaxed">
      <MarkdownComponents markdownContent={content} />
      <span className="animate-pulse ml-1 text-muted-foreground align-baseline inline">|</span>
    </div>
  );
}
